
import React from "react";
import moment from "moment";
import withCandidate from "./withCandidate";

const TemplateBody = ({ candidate }) => {
  const languages = candidate?.languages || [];
  const skills = candidate?.skills || [];
  const work = candidate?.workExperiences || [];
  const educations = candidate?.educations || [];
  const references = candidate?.references || [];
  const interests = candidate?.interests || [];

  // Helpers purs (pas d'effets)
  const formatRange = (start, end, fmt = "MMM YYYY") => {
    const s = start ? moment(start).format(fmt) : "";
    const e = end ? moment(end).format(fmt) : "Aujourd’hui";
    return s && e ? `${s} — ${e}` : s || e || "";
  };

  const guessPctFromLevel = (lvl) => {
    const L = String(lvl || "").toUpperCase().trim();
    const map = { C2: 95, C1: 85, B2: 75, B1: 60, A2: 45, A1: 30 };
    return map[L] ?? 55;
  };

  return (
    <>
      <style>{`
        /* ===================================================================
           VARIABLES DES THÈMES — portée .template-page (toutes variantes)
        =================================================================== */
        .template-page {
          --accent: #3b82f6;
          --ink: #0f172a;
          --muted: #6b7280;
          --paper: #ffffff;
          --side: #f3f6fb;
          --chip: #e5e7eb;
          --dash: #cfe3f7;
          --border: #d1d5db;
        }
        .template-page[data-theme="blue-pro"] {
          --accent: #2379B8; --ink:#0f172a; --muted:#6b7280; --paper:#ffffff;
          --side:#f1f8ff; --chip:#e8eef6; --dash:#cfe3f7; --border:#d1d5db;
        }
        .template-page[data-theme="slate"] {
          --accent:#64748b; --ink:#1e293b; --muted:#475569; --paper:#ffffff;
          --side:#f3f4f6; --chip:#e5e7eb; --dash:#dae1e7; --border:#cbd5e1;
        }
        .template-page[data-theme="emerald"] {
          --accent:#10b981; --ink:#064e3b; --muted:#5f6b67; --paper:#ffffff;
          --side:#ecfdf5; --chip:#d1fae5; --dash:#bae8d5; --border:#bfe3d6;
        }
        .template-page[data-theme="royal"] {
          --accent:#7c3aed; --ink:#1e1b4b; --muted:#6b6b9b; --paper:#ffffff;
          --side:#f5f1ff; --chip:#ede9fe; --dash:#d7ccff; --border:#ddd6fe;
        }
        .template-page[data-theme="bordeaux"] {
          --accent:#b91c1c; --ink:#1f1f1f; --muted:#7a6565; --paper:#ffffff;
          --side:#fef2f2; --chip:#fee2e2; --dash:#fbcfd0; --border:#fecaca;
        }
        .template-page[data-theme="noir-or"] {
          --accent:#d4a017; --ink:#e5e5e5; --muted:#bfbfbf; --paper:#1b1b1b;
          --side:#141414; --chip:#2a2a2a; --dash:#3a3a3a; --border:#333333;
        }
        .template-page[data-theme="bleu-clair"] {
          --accent:#3b82f6; --ink:#1e293b; --muted:#64748b; --paper:#ffffff;
          --side:#eff6ff; --chip:#dbeafe; --dash:#c7ddff; --border:#bfdbfe;
        }
        .template-page[data-theme="orange"] {
          --accent:#f97316; --ink:#1a1a1a; --muted:#6b7280; --paper:#ffffff;
          --side:#fff7ed; --chip:#fed7aa; --dash:#ffd8b5; --border:#fdba74;
        }
        .template-page[data-theme="teal"] {
          --accent:#0ea5a4; --ink:#0f172a; --muted:#5b7a85; --paper:#ffffff;
          --side:#f0fdfa; --chip:#ccfbf1; --dash:#baf2ec; --border:#99f6e4;
        }
        .template-page[data-theme="forest"] {
          --accent:#22c55e; --ink:#10231b; --muted:#5f776e; --paper:#ffffff;
          --side:#ecfdf5; --chip:#d1fae5; --dash:#c7f0de; --border:#a7f3d0;
        }
        .template-page[data-theme="rose"] {
          --accent:#e11d48; --ink:#2b0a13; --muted:#a36a7a; --paper:#ffffff;
          --side:#fff1f2; --chip:#ffe4e6; --dash:#ffd2da; --border:#fecdd3;
        }
        .template-page[data-theme="indigo"] {
          --accent:#4f46e5; --ink:#1e1b4b; --muted:#717ab9; --paper:#ffffff;
          --side:#eef2ff; --chip:#e0e7ff; --dash:#d5dcff; --border:#c7d2fe;
        }
        .template-page[data-theme="malibaara"] {
          --accent:#2379B8; --ink:#0f172a; --muted:#6b7280; --paper:#ffffff;
          --side:#f1f8ff; --chip:#e8eef6; --dash:#cfe3f7; --border:#d1d5db;
        }

        /* ===================================================================
           LAYOUT — scoping strict (aucun style global)
        =================================================================== */
        .tpl-slim {
          width: 210mm;
          min-height: 297mm;
          margin: 10px auto;
          display: grid;
          grid-template-columns: 260px 1fr;
          background: var(--paper);
          color: var(--ink);
          border: 1px solid var(--border);
          box-shadow: 0 10px 30px rgba(0,0,0,.12);
          font-family: Arial, Helvetica, sans-serif;
        }

        body { background:#222; }

        .side {
          background: var(--side);
          padding: 22px 20px 24px;
        }

        .avatar {
          width: 110px; height: 110px; border-radius: 50%;
          overflow: hidden; border: 3px solid #ffffff;
          box-shadow: 0 4px 16px rgba(0,0,0,.12);
          margin: 10px auto 14px;
        }
        .avatar img { width: 100%; height: 100%; object-fit: cover; display:block; }

        .side h4 {
          font-size: 12px; text-transform: uppercase; letter-spacing: .7px;
          color: var(--accent); margin: 14px 0 8px;
        }

        .contacts { display: grid; gap: 8px; font-size: 12px; }
        .c-row { display: grid; grid-template-columns: 18px 1fr; gap: 8px; align-items: center; }
        .c-row a { color: inherit; text-decoration: none; }

        .bullets { margin: 0; padding-left: 16px; }
        .bullets li { margin: 5px 0; font-size: 12px; }

        /* Langues */
        .lang-list { display: grid; gap: 10px; }
        .lang-item .label { display: flex; justify-content: space-between; font-size: 12px; }
        .lang-item .meta { color: var(--muted); }
        .bar { background: #e5e7eb; height: 8px; border-radius: 999px; overflow: hidden; }
        .bar > span { display:block; height:100%; background: var(--accent); }

        /* Main */
        .main {
          padding: 22px 28px 26px;
          border-left: 2px dashed var(--dash);
        }
        .name {
          color: var(--accent); font-weight: 900; font-size: 28px; margin-bottom: 12px;
        }
        .sec { margin-top: 16px; }
        .sec-title {
          display: flex; align-items: center; gap: 10px;
          color: var(--ink); font-weight: 800; font-size: 13px; text-transform: uppercase; margin-bottom: 8px;
        }
        .sec-title .dot {
          width: 22px; height: 22px; border-radius: 50%;
          border: 2px solid var(--accent);
          display: grid; place-items: center; color: var(--accent); font-size: 12px;
        }
        .para { font-size: 13px; line-height: 1.55; }

        .job { margin: 12px 0; }
        .job-head { font-weight: 800; }
        .job-sub { font-size: 12px; color: var(--muted); margin-top: 2px; }
        .job ul { margin: 6px 0 0 18px; }
        .job li { font-size: 13px; margin: 2px 0; }

        .edu-item { margin: 10px 0; }
        .interest-list { margin: 0; padding-left: 16px; }
        .interest-list li { font-size: 13px; margin: 4px 0; }
      `}</style>

      <div className="tpl-slim">
        {/* Colonne gauche */}
        <aside className="side">
          <div className="avatar">
            <img
              crossOrigin="anonymous"
              src={candidate?.profilePictureUrl || "/assets/images/avatar/avatar2.png"}
              alt=""
            />
          </div>

          <h4>Coordonnées</h4>
          <div className="contacts">
            {candidate?.address && (
              <div className="c-row"><span>📍</span><span>{candidate.address}</span></div>
            )}
            {candidate?.phoneNumber1 && (
              <div className="c-row"><span>📞</span><span>{candidate.phoneNumber1}</span></div>
            )}
            {candidate?.email && (
              <div className="c-row">
                <span>✉️</span><a href={`mailto:${candidate.email}`}>{candidate.email}</a>
              </div>
            )}
          </div>

          {!!skills.length && (
            <>
              <h4>Compétences</h4>
              <ul className="bullets">
                {skills.map((s, i) => <li key={i}>{s?.title}</li>)}
              </ul>
            </>
          )}

          {!!languages.length && (
            <>
              <h4>Langues</h4>
              <div className="lang-list">
                {languages.map((l, i) => {                  
                  return (
                    <div className="lang-item" key={i}>
                      <div className="label">
                        <span>{l?.name} - Écrit</span>
                        <span className="meta">{l?.writingLevel}</span>
                      </div>
                      <div className="bar"><span style={{ width: `${l?.writingLevel * 10}%` }} /></div>
                      <div className="label" style={{marginTop: "10px"}}>
                        <span>{l?.name} - Parlé</span>
                        <span className="meta">{l?.speakingLevel}</span>
                      </div>
                      <div className="bar"><span style={{ width: `${l?.speakingLevel * 10}%` }} /></div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </aside>

        {/* Colonne droite */}
        <main className="main">
          <div className="name">
            {candidate?.firstName} {candidate?.lastName}
          </div>

          {/* Profil professionnel */}
          <section className="sec">
            <div className="sec-title">
              <span className="dot">i</span><span>Profil professionnel</span>
            </div>
            <div
              className="para"
              dangerouslySetInnerHTML={{ __html: candidate?.summaryDescription || "" }}
            />
          </section>

          {/* Parcours professionnel */}
          {!!work.length && (
            <section className="sec">
              <div className="sec-title">
                <span className="dot">✦</span><span>Parcours professionnel</span>
              </div>
              {work.map((job, i) => (
                <div className="job" key={i}>
                  <div className="job-head">{job?.title}</div>
                  <div className="job-sub">
                    {job?.company ? `${job.company} — ` : ""}
                    {formatRange(job?.startDate, job?.endDate)}
                  </div>
                  {job?.description && <div className="para">{job.description}</div>}
                  {Array.isArray(job?.achievements) && job.achievements.length > 0 && (
                    <ul>
                      {job.achievements.map((a, k) => <li key={k}>{a}</li>)}
                    </ul>
                  )}
                </div>
              ))}
            </section>
          )}

          {/* Formation */}
          {!!educations.length && (
            <section className="sec">
              <div className="sec-title">
                <span className="dot">🎓</span><span>Formation</span>
              </div>
              {educations.map((edu, i) => (
                <div className="edu-item" key={i}>
                  <div className="job-head">{edu?.degree}</div>
                  <div className="job-sub">
                    {edu?.institution}                    
                    {edu?.description} {(edu?.startYear || edu?.endYear) &&
                      ` — ${edu?.startYear || ""}${edu?.endYear ? ` – ${edu.endYear}` : ""}`}
                  </div>
                </div>
              ))}
            </section>
          )}

          {/* Reference */}
          {!!references.length && (
            <section className="sec">
              <div className="sec-title">
                <span className="dot">◆</span><span>Références</span>
              </div>
              {references.map((ref, i) => (
                <div className="job" key={i}>
                  <div className="job-head">{ref?.fullName}</div>
                  <div className="job-sub">
                    {ref?.title}
                  </div>
                  <div className="para">
                    Tel: {ref.phoneNumber1} / {ref.phoneNumber2} <br />
                    Email: {ref.email}
                  </div>
                </div>
              ))}
            </section>
          )}
        </main>
      </div>
    </>
  );
};

export default withCandidate(TemplateBody, "Simple Deux Colonnes 1");
